import { isSSR } from '@k2/core/util'
import { useOAuth } from 'vue-oidc'
import type { NavigationGuardWithThis, RouteLocationNormalized, RouteLocationRaw } from 'vue-router'

export const isNotAuthorizedGuard: NavigationGuardWithThis<undefined> = async (to: RouteLocationNormalized) => {
  if (isSSR) return true

  const { isAuthorized } = useOAuth()
  if (!isAuthorized.value) return true

  const { returnUrl } = to.query
  return ((typeof returnUrl === 'string' && { path: returnUrl }) || { name: 'home' }) as RouteLocationRaw
}
